import { render, staticRenderFns } from "./patientProfileDetails.vue?vue&type=template&id=0f0358b1&scoped=true"
import script from "./patientProfileDetails.vue?vue&type=script&lang=js"
export * from "./patientProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./patientProfileDetails.vue?vue&type=style&index=0&id=0f0358b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0358b1",
  null
  
)

export default component.exports